export default __webpack_public_path__ + "static/media/Guarantee.ca8c00b6.svg";